import React from 'react';

import { INotificationGridItem } from '../notification-grid';

import { DetailsRow } from './DetailsRow';
import { LeadInfo } from './utils';

export const EconomicProfileChangedDetails: React.FC<INotificationGridItem> = ({
  date,
  notificationDetails: { data },
}) => {
  const teamManager = data.managerId ? (
    <DetailsRow
      label="Manager ID"
      value={`${data.managerId}, ${data.managerName}`}
    />
  ) : null;

  return (
    <>
      <DetailsRow label="Date" value={date} />
      <DetailsRow
        label="Client ID"
        component={<LeadInfo leadId={data.leadId} />}
      />
      <DetailsRow label="Name" value={data.leadFullName} />
      <DetailsRow
        label="Message"
        value="filled out the Economic profile form"
      />
      {teamManager}
    </>
  );
};
